import React, { useState, useContext } from 'react';
import { I18nContext } from 'translations';
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  IconButton,
  TextField,
  CircularProgress,
  Snackbar,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { useStateValue } from 'context/store';
import { updateCompanyChangeComment } from 'context/settings/companyRegister/actions';
import { message as clearMessage } from 'context/commons/actions';

const ModalLimitante = ({ open, companyId, onClose }) => {
  const { translate } = useContext(I18nContext);
  const [{ commons: { message } }, dispatch] = useStateValue();
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setComment('');
    onClose && onClose();
  };

  const handleSubmit = async () => {
    setLoading(true);
    await updateCompanyChangeComment(dispatch, companyId, comment);
    setLoading(false);
    window.location.reload();
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="xs"
        fullWidth
        PaperProps={{ style: { borderRadius: '16px', padding: '8px' } }}
      >
        <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '8px 8px 0' }}>
          <IconButton size="small" onClick={handleClose} disabled={loading}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>

        <DialogContent style={{ padding: '0 28px 28px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
            <ErrorOutlineIcon style={{ color: '#F59E0B', fontSize: 28 }} />
            <Typography variant="h6" style={{ fontWeight: 700, color: '#111' }}>
              {translate('company.change.limitante.title')}
            </Typography>
          </div>

          <Typography variant="body2" style={{ color: '#555', marginBottom: '20px', lineHeight: 1.6 }}>
            {translate('company.change.limitante.descriptionBefore')} <b>{translate('company.change.limitante.kam')}</b> {translate('company.change.limitante.descriptionAfter')}
          </Typography>

          <TextField
            multiline
            rows={4}
            fullWidth
            variant="outlined"
            placeholder={translate('company.change.limitante.placeholder')}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            inputProps={{ maxLength: 500 }}
            disabled={loading}
            style={{ marginBottom: '8px' }}
          />

          <Typography
            variant="caption"
            style={{ color: '#AAA', display: 'block', textAlign: 'right', marginBottom: '20px' }}
          >
            {comment.length}/500
          </Typography>

          <Button
            fullWidth
            variant="contained"
            color="primary"
            disabled={!comment.trim() || loading}
            onClick={handleSubmit}
            style={{
              borderRadius: '10px',
              padding: '12px',
              textTransform: 'none',
              fontSize: '15px',
              fontWeight: 600,
            }}
          >
            {loading ? <CircularProgress size={22} color="inherit" /> : translate('company.change.limitante.submit')}
          </Button>
        </DialogContent>
      </Dialog>

      <Snackbar
        open={message === 'company.change.comment.success'}
        autoHideDuration={4000}
        onClose={() => clearMessage(dispatch, null)}
        message="Comentario enviado correctamente"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
    </>
  );
};

export default ModalLimitante;
